import { GET_GM_CURRENCY, GET_GM_CURRENCY_SUCCESS, GET_GM_CURRENCY_ERROR, GET_GM_CURRENCY_EMPTY } from '../../actions';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const GetGmCurrency = (state = initialState, action) => {
  switch (action.type) {
    case GET_GM_CURRENCY:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case GET_GM_CURRENCY_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case GET_GM_CURRENCY_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case GET_GM_CURRENCY_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default GetGmCurrency;